export default {
  weight: {
    wage: {
      7.25: 0.0,
      7.26: 0.001165651938089292,
      7.27: 0.002330420415281627,
      7.28: 0.0034943076054341467,
      7.29: 0.004657315675055021,
      '7.30': 0.005819446783311693,
      7.31: 0.00698070308204093,
      7.32: 0.008141086715752947,
      7.33: 0.009300599821643005,
      7.34: 0.010459244529604549,
      7.35: 0.011617022962234113,
      7.36: 0.012773937234838523,
      7.37: 0.013929989455446509,
      7.38: 0.015085181724820547,
      7.39: 0.01623951613646047,
      '7.40': 0.017392994776616107,
      7.41: 0.018545619724291897,
      7.42: 0.01969739305126366,
      7.43: 0.02084831682208144,
      7.44: 0.021998393094078743,
      7.45: 0.023147623917383155,
      7.46: 0.0242960113349266,
      7.47: 0.025443557382453116,
      7.48: 0.026590264088525776,
      7.49: 0.027736133474537017,
      '7.50': 0.02888116755472153,
      7.51: 0.030025368336161904,
      7.52: 0.031168737818793292,
      7.53: 0.03231127799541989,
      7.54: 0.03345299085172086,
      7.55: 0.034593878366261176,
      7.56: 0.03573394251049494,
      7.57: 0.036873185248779854,
      7.58: 0.038011608538385415,
      7.59: 0.03914921432950406,
      '7.60': 0.04028600456525136,
      7.61: 0.04142198118168385,
      7.62: 0.04255714610780597,
      7.63: 0.04369150126557932,
      7.64: 0.04482504856992838,
      7.65: 0.045957789928750506,
      7.66: 0.047089727242931166,
      7.67: 0.048220862406345745,
      7.68: 0.04935119730586932,
      7.69: 0.05048073382138854,
      '7.70': 0.05160947382580906,
      7.71: 0.052737419185066935,
      7.72: 0.05386457175813422,
      7.73: 0.05499093339702575,
      7.74: 0.05611650594681762,
      7.75: 0.057241291245648786,
      7.76: 0.05836529112472877,
      7.77: 0.059488507408350794,
      7.78: 0.06061094191390213,
      7.79: 0.06173259645186868,
      '7.80': 0.06285347282584508,
      7.81: 0.06397357283254394,
      7.82: 0.06509289826180749,
      7.83: 0.06621145089661674,
      7.84: 0.0673292325130922,
      7.85: 0.06844624488051142,
      7.86: 0.06956248976131743,
      7.87: 0.07067796891112639,
      7.88: 0.07179268407873246,
      7.89: 0.0729066370061223,
      '7.90': 0.074019829428483,
      7.91: 0.07513226307421088,
      7.92: 0.07624393966491896,
      7.93: 0.07735486091544466,
      7.94: 0.07846502853386426,
      7.95: 0.07957444422150037,
      7.96: 0.08068310967292552,
      7.97: 0.0817910265759756,
      7.98: 0.08289819661176064,
      7.99: 0.08400462145467126,
      '8.00': 0.08511030277238617,
      8.01: 0.0862152422258822,
      8.02: 0.08731944146944746,
      8.03: 0.08842290215068596,
      8.04: 0.08952562591052661,
      8.05: 0.09062761438323179,
      8.06: 0.09172886919641093,
      8.07: 0.09282939197102703,
      8.08: 0.09392918432140124,
      8.09: 0.09502824785522807,
      '8.10': 0.09612658417358237,
      8.11: 0.0972241948709289,
      8.12: 0.09832108153512867,
      8.13: 0.0994172457474483,
      8.14: 0.10051268908257417,
      8.15: 0.10160741310861812,
      8.16: 0.10270141938712253,
      8.17: 0.10379470947307456,
      8.18: 0.1048872849149136,
      8.19: 0.10597914725454338,
      '8.20': 0.10707029802733199,
      8.21: 0.10816073876213092,
      8.22: 0.10925047098127842,
      8.23: 0.11033949620061215,
      8.24: 0.111427815929473,
      8.25: 0.11251543167071802,
      8.26: 0.11360234492073074,
      8.27: 0.1146885571694265,
      8.28: 0.11577406990026361,
      8.29: 0.116858884590249,
      '8.30': 0.11794300270995314,
      8.31: 0.11902642572351808,
      8.32: 0.12010915508865894,
      8.33: 0.12119119225668043,
      8.34: 0.12227253867248536,
      8.35: 0.12335319577458032,
      8.36: 0.12443316499508901,
      8.37: 0.12551244775975237,
      8.38: 0.12659104548795216,
      8.39: 0.12766895959270738,
      '8.40': 0.12874619148068728,
      8.41: 0.12982274255222093,
      8.42: 0.13089861420130774,
      8.43: 0.13197380781562454,
      8.44: 0.1330483247765331,
      8.45: 0.13412216645909178,
      8.46: 0.13519533423206337,
      8.47: 0.13626782945792665,
      8.48: 0.13733965349288155,
      8.49: 0.13841080768685604,
      '8.50': 0.13948129338352563,
      8.51: 0.14055111192031297,
      8.52: 0.1416202646283984,
      8.53: 0.1426887528327288,
      8.54: 0.14375657785203125,
      8.55: 0.14482374099881984,
      8.56: 0.14589024357939825,
      8.57: 0.14695608689387699,
      8.58: 0.1480212722361798,
      8.59: 0.14908580089405513,
      '8.60': 0.15014967414907696,
      8.61: 0.15121289327666043,
      8.62: 0.15227545954607216,
      8.63: 0.15333737422043808,
      8.64: 0.15439863855674615,
      8.65: 0.15545925380586306,
      8.66: 0.1565192212125417,
      8.67: 0.15757854201542837,
      8.68: 0.15863721744707163,
      8.69: 0.15969524873393112,
      '8.70': 0.16075263709639093,
      8.71: 0.16180938374876408,
      8.72: 0.16286548989930216,
      8.73: 0.16392095675020346,
      8.74: 0.16497578549762704,
      8.75: 0.16602997733169694,
      8.76: 0.16708353343651108,
      8.77: 0.16813645499015126,
      8.78: 0.169188743164696,
      8.79: 0.1702403991262242,
      '8.80': 0.1712914240348263,
      8.81: 0.17234181904461102,
      8.82: 0.17339158530371843,
      8.83: 0.1744407239543292,
      8.84: 0.1754892361326676,
      8.85: 0.17653712296901558,
      8.86: 0.17758438558772185,
      8.87: 0.17863102510720874,
      8.88: 0.17967704263998163,
      8.89: 0.18072243929263782,
      '8.90': 0.181767216165878,
      8.91: 0.18281137435451428,
      8.92: 0.1838549149474744,
      8.93: 0.1848978390278164,
      8.94: 0.18594014767273823,
      8.95: 0.18698184195358283,
      8.96: 0.18802292293584927,
      8.97: 0.18906339167919764,
      8.98: 0.19010324923746655,
      8.99: 0.19114249665867722,
      '9.00': 0.19218113498503955,
      9.01: 0.19321916525296437,
      9.02: 0.19425658849307487,
      9.03: 0.19529340573021223,
      9.04: 0.1963296179834455,
      9.05: 0.19736522626607705,
      9.06: 0.19840023158565964,
      9.07: 0.19943463494399993,
      9.08: 0.20046843733716707,
      9.09: 0.20150163975550298,
      '9.10': 0.20253424318363314,
      9.11: 0.20356624860047412,
      9.12: 0.20459765697924098,
      9.13: 0.2056284692874554,
      9.14: 0.20665868648696326,
      9.15: 0.20768830953393375,
      9.16: 0.20871733937887227,
      9.17: 0.20974577696662672,
      9.18: 0.2107736232364042,
      9.19: 0.21180087912177395,
      '9.20': 0.21282754555067307,
      9.21: 0.21385362344542247,
      9.22: 0.21487911372273444,
      9.23: 0.21590401729371997,
      9.24: 0.21692833506389664,
      9.25: 0.21795206793319777,
      9.26: 0.21897521679598872,
      9.27: 0.21999778254106558,
      9.28: 0.22101976605166884,
      9.29: 0.22204116820549244,
      '9.30': 0.22306198987469475,
      9.31: 0.22408223192590385,
      9.32: 0.2251018952202275,
      9.33: 0.22612098061326347,
      9.34: 0.2271394889551083,
      9.35: 0.22815742109036607,
      9.36: 0.22917477785815638,
      9.37: 0.2301915600921231,
      9.38: 0.2312077686204481,
      9.39: 0.23222340426585394,
      '9.40': 0.2332384678456164,
      9.41: 0.23425296017157154,
      9.42: 0.23526688205012777,
      9.43: 0.23628023428227463,
      9.44: 0.23729301766358446,
      9.45: 0.23830523298423228,
      9.46: 0.23931688102899773,
      9.47: 0.2403279625772768,
      9.48: 0.24133847840308967,
      9.49: 0.2423484292750881,
      '9.50': 0.2433578159565705,
      9.51: 0.24436663920548585,
      9.52: 0.24537489977444138,
      9.53: 0.24638259841071508,
      9.54: 0.24738973585626453,
      9.55: 0.2483963128477368,
      9.56: 0.2494023301164718,
      9.57: 0.25040778838851646,
      9.58: 0.25141268838463343,
      9.59: 0.25241703082031114,
      '9.60': 0.2534208164057663,
      9.61: 0.2544240458459598,
      9.62: 0.2554267198406031,
      9.63: 0.2564288390841705,
      9.64: 0.25743040426589986,
      9.65: 0.2584314160698097,
      9.66: 0.2594318751747063,
      9.67: 0.2604317822541922,
      9.68: 0.26143113797667183,
      9.69: 0.2624299430053655,
      '9.70': 0.26342819799831724,
      9.71: 0.2644259036084036,
      9.72: 0.2654230604833407,
      9.73: 0.26641966926569294,
      9.74: 0.2674157305928879,
      9.75: 0.2684112450972195,
      9.76: 0.2694062134058585,
      9.77: 0.27040063614086024,
      9.78: 0.27139451391917896,
      9.79: 0.27238784735267135,
      '9.80': 0.2733806370481069,
      9.81: 0.2743728836071757,
      9.82: 0.27536458762650134,
      9.83: 0.276355749697649,
      9.84: 0.27734637040713106,
      9.85: 0.27833645033641646,
      9.86: 0.2793259900619445,
      9.87: 0.28031499015513156,
      9.88: 0.2813034511823759,
      9.89: 0.28229137370507074,
      '9.90': 0.2832787582796153,
      9.91: 0.28426560545742063,
      9.92: 0.28525191578491743,
      9.93: 0.286237689803567,
      9.94: 0.2872229280498712,
      9.95: 0.2882076310553813,
      9.96: 0.2891917993467044,
      9.97: 0.2901754334455116,
      9.98: 0.2911585338685561,
      9.99: 0.2921411011276715,
      '10.00': 0.2931231357297843,
      10.01: 0.29410463817692417,
      10.02: 0.2950856089662344,
      10.03: 0.29606604858997815,
      10.04: 0.29704595753554686,
      10.05: 0.2980253362854702,
      10.06: 0.29900418531742745,
      10.07: 0.2999825051042553,
      10.08: 0.3009602961139536,
      10.09: 0.3019375588096966,
      '10.10': 0.3029142936498463,
      10.11: 0.3038905010879542,
      10.12: 0.3048661815727743,
      10.13: 0.3058413355482699,
      10.14: 0.30681596345362755,
      10.15: 0.30779006572326073,
      10.16: 0.3087636427868214,
      10.17: 0.3097366950692054,
      10.18: 0.31070922299056886,
      10.19: 0.3116812269663314,
      '10.20': 0.3126527074071858,
      10.21: 0.3136236647191068,
      10.22: 0.3145940993033635,
      10.23: 0.31556401155652597,
      10.24: 0.31653340187047246,
      10.25: 0.31750227063239905,
      10.26: 0.3184706182248345,
      10.27: 0.31943844502564234,
      10.28: 0.3204057514080311,
      10.29: 0.3213725377405646,
      '10.30': 0.3223388043871712,
      10.31: 0.32330455170715494,
      10.32: 0.32426978005519785,
      10.33: 0.32523448978137537,
      10.34: 0.3261986812311621,
      10.35: 0.3271623547454445,
      10.36: 0.3281255106605247,
      10.37: 0.32908814930813124,
      10.38: 0.3300502710154315,
      10.39: 0.33101187610503807,
      '10.40': 0.3319729648950153,
      10.41: 0.3329335376988932,
      10.42: 0.3338935948256727,
      10.43: 0.33485313657983845,
      10.44: 0.33581216326136276,
      10.45: 0.33677067516571807,
      10.46: 0.3377286725838855,
      10.47: 0.33868615580236516,
      10.48: 0.3396431251031816,
      10.49: 0.3405995807638937,
      '10.50': 0.34155552305760767,
      10.51: 0.342510952252984,
      10.52: 0.343465868614242,
      10.53: 0.34442027240117334,
      10.54: 0.3453741638691534,
      10.55: 0.34632754326914517,
      10.56: 0.34728041084770894,
      10.57: 0.3482327668470136,
      10.58: 0.34918461150484525,
      10.59: 0.3501359450546168,
      '10.60': 0.35108676772537345,
      10.61: 0.35203707974180376,
      10.62: 0.35298688132425127,
      10.63: 0.3539361726887211,
      10.64: 0.35488495404688813,
      10.65: 0.355833225606105,
      10.66: 0.35678098756941795,
      10.67: 0.35772824013556787,
      10.68: 0.3586749834990024,
      10.69: 0.3596212178498854,
      '10.70': 0.3605669433741064,
      10.71: 0.3615121602532888,
      10.72: 0.36245686866479837,
      10.73: 0.3634010687817515,
      10.74: 0.3643447607730278,
      10.75: 0.3652879448032763,
      10.76: 0.3662306210329243,
      10.77: 0.3671727896181864,
      10.78: 0.3681144507110763,
      10.79: 0.369055604459413,
      '10.80': 0.36999625100682987,
      10.81: 0.3709363904927838,
      10.82: 0.37187602305256545,
      10.83: 0.3728151488173106,
      10.84: 0.37375376791400133,
      10.85: 0.37469188046548113,
      10.86: 0.3756294865904643,
      10.87: 0.3765665864035434,
      10.88: 0.3775031800151966,
      10.89: 0.3784392675317974,
      '10.90': 0.3793748490556278,
      10.91: 0.3803099246848828,
      10.92: 0.3812444945136796,
      10.93: 0.38217855863206673,
      10.94: 0.38311211712603704,
      10.95: 0.3840451700775334,
      10.96: 0.3849777175644554,
      10.97: 0.38590975966067165,
      10.98: 0.3868412964360309,
      10.99: 0.38777232795636607,
      '11.00': 0.38870285428350565,
      11.01: 0.3896328754752816,
      11.02: 0.3905623915855414,
      11.03: 0.3914914026641553,
      11.04: 0.39241990875702265,
      11.05: 0.3933479099060839,
      11.06: 0.39427540614933027,
      11.07: 0.3952023975208118,
      11.08: 0.39612888405064495,
      11.09: 0.39705486576502147,
      '11.10': 0.39798034268622146,
      11.11: 0.398905314832619,
      11.12: 0.3998297822186912,
      11.13: 0.40075374485502663,
      11.14: 0.4016772027483375,
      11.15: 0.40260015590146725,
      11.16: 0.4035226043133968,
      11.17: 0.4044445479792563,
      11.18: 0.4053659868903345,
      11.19: 0.40628692103408814,
      '11.20': 0.40720735039414707,
      11.21: 0.4081272749503261,
      11.22: 0.4090466946786364,
      11.23: 0.40996560955129085,
      11.24: 0.4108840195367132,
      11.25: 0.4118019245995476,
      11.26: 0.41271932470067035,
      11.27: 0.4136362197971961,
      11.28: 0.4145526098424865,
      11.29: 0.4154684947861592,
      '11.30': 0.41638387457410037,
      11.31: 0.4172987491484711,
      11.32: 0.41821311844771386,
      11.33: 0.419126982406565,
      11.34: 0.4200403409560653,
      11.35: 0.42095319402356446,
      11.36: 0.4218655415327325,
      11.37: 0.42277738340356785,
      11.38: 0.4236887195524094,
      11.39: 0.4245995498919415,
      '11.40': 0.425509874331205,
      11.41: 0.42641969277560426,
      11.42: 0.42732900512692074,
      11.43: 0.4282378112833188,
      11.44: 0.4291461111393529,
      11.45: 0.4300539045859796,
      11.46: 0.4309611915105656,
      11.47: 0.43186797179689945,
      11.48: 0.43277424532519476,
      11.49: 0.433680011972102,
      '11.50': 0.4345852716107215,
      11.51: 0.4354900241106069,
      11.52: 0.43639426933777636,
      11.53: 0.43729800715472045,
      11.54: 0.4382012374204131,
      11.55: 0.43910395999032176,
      11.56: 0.44000617471641107,
      11.57: 0.44090788144715515,
      11.58: 0.441809080027549,
      11.59: 0.44270977029911496,
      '11.60': 0.4436099520999097,
      11.61: 0.44450962526453597,
      11.62: 0.44540878962415287,
      11.63: 0.4463074450064827,
      11.64: 0.44720559123581866,
      11.65: 0.44810322813303594,
      11.66: 0.44900035551560175,
      11.67: 0.44989697319758315,
      11.68: 0.45079308098965376,
      11.69: 0.4516886786991061,
      '11.70': 0.45258376612985896,
      11.71: 0.4534783430824695,
      11.72: 0.454372409354136,
      11.73: 0.4552659647387104,
      11.74: 0.45615900902671075,
      11.75: 0.4570515420053257,
      11.76: 0.457943563458423,
      11.77: 0.4588350731665614,
      11.78: 0.4597260709069985,
      11.79: 0.46061655645370125,
      '11.80': 0.4615065295773505,
      11.81: 0.46239599004535414,
      11.82: 0.4632849376218564,
      11.83: 0.46417337206774545,
      11.84: 0.4650612931406599,
      11.85: 0.46594870059500143,
      11.86: 0.4668355941819448,
      11.87: 0.4677219736494437,
      11.88: 0.46860783874223855,
      11.89: 0.46949318920187,
      '11.90': 0.47037802476668583,
      11.91: 0.47126234517185095,
      11.92: 0.47214615014935224,
      11.93: 0.4730294394280124,
      11.94: 0.4739122127334979,
      11.95: 0.47479446978832757,
      11.96: 0.4756762103118805,
      11.97: 0.47655743402040485,
      11.98: 0.4774381406270302,
      11.99: 0.47831832984177464,
      '12.00': 0.47919800137155116,
      12.01: 0.48007715492018027,
      12.02: 0.4809557901883986,
      12.03: 0.4818339068738665,
      12.04: 0.4827115046711773,
      12.05: 0.48358858327186577,
      12.06: 0.4844651423644201,
      12.07: 0.4853411816342888,
      12.08: 0.48621670076388845,
      12.09: 0.4870916994326132,
      '12.10': 0.4879661773168476,
      12.11: 0.48884013408997146,
      12.12: 0.4897135694223688,
      12.13: 0.4905864829814385,
      12.14: 0.4914588744316042,
      12.15: 0.49233074343432315,
      12.16: 0.49320208964809037,
      12.17: 0.49407291272845366,
      12.18: 0.4949432123280206,
      12.19: 0.4958129880964683,
      '12.20': 0.49668223968054903,
      12.21: 0.49755096672410304,
      12.22: 0.49841916886806614,
      12.23: 0.49928684575048043,
      12.24: 0.5001539970064994,
      12.25: 0.5010206222683978,
      12.26: 0.5018867211655873,
      12.27: 0.5027522933246173,
      12.28: 0.5036173383691862,
      12.29: 0.5044818559201515,
      '12.30': 0.50534584559554,
      12.31: 0.5062093070105556,
      12.32: 0.5070722397775856,
      12.33: 0.5079346435062131,
      12.34: 0.5087965178032261,
      12.35: 0.5096578622726263,
      12.36: 0.5105186765156352,
      12.37: 0.5113789601307044,
      12.38: 0.5122387127135288,
      12.39: 0.5130979338570506,
      '12.40': 0.5139566231514701,
      12.41: 0.5148147801842526,
      12.42: 0.5156724045401437,
      12.43: 0.5165294958011719,
      12.44: 0.5173860535466582,
      12.45: 0.518242077353228,
      12.46: 0.5190975667948197,
      12.47: 0.5199525214426927,
      12.48: 0.5208069408654356,
      12.49: 0.5216608246289751,
      '12.50': 0.5225141722965887,
      12.51: 0.5233669834289109,
      12.52: 0.5242192575839404,
      12.53: 0.525070994317051,
      12.54: 0.5259221931810036,
      12.55: 0.5267728537259513,
      12.56: 0.5276229754994478,
      12.57: 0.5284725580464589,
      12.58: 0.5293216009093715,
      12.59: 0.530170103628003,
      '12.60': 0.5310180657396063,
      12.61: 0.5318654867788825,
      12.62: 0.5327123662779899,
      12.63: 0.5335587037665537,
      12.64: 0.5344044987716706,
      12.65: 0.5352497508179208,
      12.66: 0.5360944594273803,
      12.67: 0.5369386241196241,
      12.68: 0.5377822444117379,
      12.69: 0.5386253198183262,
      '12.70': 0.5394678498515239,
      12.71: 0.5403098340210035,
      12.72: 0.5411512718339823,
      12.73: 0.541992162795234,
      12.74: 0.5428325064070966,
      12.75: 0.5436723021694844,
      12.76: 0.5445115495798906,
      12.77: 0.545350248133401,
      12.78: 0.5461883973227037,
      12.79: 0.547025996638097,
      '12.80': 0.5478630455674949,
      12.81: 0.5486995435964407,
      12.82: 0.5495354902081151,
      12.83: 0.550370884883345,
      12.84: 0.5512057271006109,
      12.85: 0.5520400163360559,
      12.86: 0.5528737520634989,
      12.87: 0.5537069337544401,
      12.88: 0.5545395608780689,
      12.89: 0.5553716329012747,
      '12.90': 0.556203149288658,
      12.91: 0.5570341095025361,
      12.92: 0.5578645130029527,
      12.93: 0.5586943592476865,
      12.94: 0.559523647692264,
      12.95: 0.5603523777899652,
      12.96: 0.5611805489918307,
      12.97: 0.5620081607466748,
      12.98: 0.5628352125010929,
      12.99: 0.5636617036994718,
      '13.00': 0.5644876337839947,
      13.01: 0.5653130021946533,
      13.02: 0.5661378083692588,
      13.03: 0.5669620517434478,
      13.04: 0.5677857317506907,
      13.05: 0.5686088478223018,
      13.06: 0.5694313993874502,
      13.07: 0.5702533858731682,
      13.08: 0.5710748067043571,
      13.09: 0.571895661303798,
      '13.10': 0.5727159490921637,
      13.11: 0.573535669488025,
      13.12: 0.5743548219078584,
      13.13: 0.5751734057660564,
      13.14: 0.5759914204749396,
      13.15: 0.5768088654447617,
      13.16: 0.5776257400837193,
      13.17: 0.5784420437979604,
      13.18: 0.5792577759915967,
      13.19: 0.5800729360667098,
      '13.20': 0.5808875234233609,
      13.21: 0.5817015374595974,
      13.22: 0.5825149775714669,
      13.23: 0.5833278431530236,
      13.24: 0.5841401335963351,
      13.25: 0.5849518482914952,
      13.26: 0.5857629866266304,
      13.27: 0.586573547987912,
      13.28: 0.5873835317595598,
      13.29: 0.5881929373238551,
      '13.30': 0.589001764061151,
      13.31: 0.5898100113498774,
      13.32: 0.590617678566552,
      13.33: 0.5914247650857892,
      13.34: 0.5922312702803096,
      13.35: 0.5930371935209493,
      13.36: 0.5938425341766665,
      13.37: 0.5946472916145523,
      13.38: 0.595451465199841,
      13.39: 0.5962550542959179,
      '13.40': 0.5970580582643268,
      13.41: 0.5978604764647789,
      13.42: 0.5986623082551676,
      13.43: 0.5994635529915705,
      13.44: 0.6002642100282616,
      13.45: 0.6010642787177182,
      13.46: 0.6018637584106341,
      13.47: 0.6026626484559259,
      13.48: 0.6034609482007409,
      13.49: 0.6042586569904664,
      '13.50': 0.6050557741687431,
      13.51: 0.6058522990774687,
      13.52: 0.606648231056809,
      13.53: 0.6074435694452059,
      13.54: 0.60823831357939,
      13.55: 0.6090324627943855,
      13.56: 0.6098260164235207,
      13.57: 0.6106189737984369,
      13.58: 0.6114113342490974,
      13.59: 0.6122030971037992,
      '13.60': 0.6129942616891761,
      13.61: 0.613784827330212,
      13.62: 0.6145747933502508,
      13.63: 0.6153641590710024,
      13.64: 0.6161529238125536,
      13.65: 0.6169410868933743,
      13.66: 0.6177286476303316,
      13.67: 0.6185156053386958,
      13.68: 0.6193019593321477,
      13.69: 0.6200877089227893,
      '13.70': 0.6208728534211554,
      13.71: 0.6216573921362191,
      13.72: 0.6224413243754019,
      13.73: 0.6232246494445813,
      13.74: 0.6240073666481031,
      13.75: 0.6247894752887898,
      13.76: 0.6255709746679449,
      13.77: 0.6263518640853672,
      13.78: 0.6271321428393588,
      13.79: 0.6279118102267338,
      '13.80': 0.6286908655428243,
      13.81: 0.629469308081493,
      13.82: 0.630247137135143,
      13.83: 0.6310243519947241,
      13.84: 0.6318009519497416,
      13.85: 0.632576936288267,
      13.86: 0.6333523042969476,
      13.87: 0.6341270552610142,
      13.88: 0.6349011884642889,
      13.89: 0.635674703189196,
      '13.90': 0.6364475987167718,
      13.91: 0.6372198743266723,
      13.92: 0.6379915292971812,
      13.93: 0.6387625629052195,
      13.94: 0.6395329744263565,
      13.95: 0.640302763134818,
      13.96: 0.6410719283034928,
      13.97: 0.6418404692039442,
      13.98: 0.6426083851064185,
      13.99: 0.6433756752798555,
      '14.00': 0.6441423389918933,
      14.01: 0.6449083755088805,
      14.02: 0.6456737840958872,
      14.03: 0.6464385640167086,
      14.04: 0.6472027145338783,
      14.05: 0.647966234908676,
      14.06: 0.6487291244011364,
      14.07: 0.6494913822700572,
      14.08: 0.6502530077730105,
      14.09: 0.6510140001663507,
      '14.10': 0.651774358705222,
      14.11: 0.6525340826435704,
      14.12: 0.6532931712341496,
      14.13: 0.654051623728532,
      14.14: 0.6548094393771178,
      14.15: 0.6555666174291428,
      14.16: 0.6563231571326884,
      14.17: 0.6570790577346898,
      14.18: 0.6578343184809462,
      14.19: 0.6585889386161283,
      '14.20': 0.6593429173837891,
      14.21: 0.6600962540263708,
      14.22: 0.6608489477852162,
      14.23: 0.6616009979005758,
      14.24: 0.6623524036116167,
      14.25: 0.6631031641564348,
      14.26: 0.6638532787720588,
      14.27: 0.6646027466944627,
      14.28: 0.6653515671585756,
      14.29: 0.666099739398287,
      '14.30': 0.6668472626464588,
      14.31: 0.667594136134933,
      14.32: 0.668340359094542,
      14.33: 0.6690859307551159,
      14.34: 0.6698308503454932,
      14.35: 0.6705751170935284,
      14.36: 0.6713187302261009,
      14.37: 0.6720616889691268,
      14.38: 0.6728039925475642,
      14.39: 0.6735456401854244,
      '14.40': 0.6742866311057805,
      14.41: 0.6750269645307764,
      14.42: 0.6757666396816348,
      14.43: 0.676505655778668,
      14.44: 0.6772440120412867,
      14.45: 0.6779817076880071,
      14.46: 0.6787187419364614,
      14.47: 0.6794551140034082,
      14.48: 0.6801908231047379,
      14.49: 0.6809258684554845,
      '14.50': 0.6816602492698342,
      14.51: 0.6823939647611338,
      14.52: 0.6831270141419002,
      14.53: 0.6838593966238299,
      14.54: 0.684591111417805,
      14.55: 0.6853221577339075,
      14.56: 0.6860525347814238,
      14.57: 0.6867822417688553,
      14.58: 0.687511277903928,
      14.59: 0.6882396423936007,
      '14.60': 0.6889673344440743,
      14.61: 0.6896943532608006,
      14.62: 0.6904206980484916,
      14.63: 0.6911463680111289,
      14.64: 0.6918713623519711,
      14.65: 0.6925956802735652,
      14.66: 0.6933193209777542,
      14.67: 0.6940422836656851,
      14.68: 0.6947645675378207,
      14.69: 0.6954861717939461,
      '14.70': 0.6962070956331785,
      14.71: 0.6969273382539776,
      14.72: 0.697646898854152,
      14.73: 0.6983657766308697,
      14.74: 0.6990839707806682,
      14.75: 0.6998014804994616,
      14.76: 0.7005183049825499,
      14.77: 0.7012344434246295,
      14.78: 0.7019498950198,
      14.79: 0.7026646589615759,
      '14.80': 0.7033787344428931,
      14.81: 0.7040921206561189,
      14.82: 0.7048048167930617,
      14.83: 0.7055168220449787,
      14.84: 0.7062281356025862,
      14.85: 0.7069387566560679,
      14.86: 0.7076486843950838,
      14.87: 0.70835791800878,
      14.88: 0.7090664566857959,
      14.89: 0.7097742996142765,
      '14.90': 0.7104814459818778,
      14.91: 0.7111878949757781,
      14.92: 0.7118936457826858,
      14.93: 0.7125986975888504,
      14.94: 0.713303049580068,
      14.95: 0.7140067009416947,
      14.96: 0.7147096508586509,
      14.97: 0.7154118985154352,
      14.98: 0.7161134430961292,
      14.99: 0.716814283784409,
      '15.00': 0.7175144197635533,
      15.01: 0.7182138502164527,
      15.02: 0.718912574325619,
      15.03: 0.7196105912731932,
      15.04: 0.7203079002409556,
      15.05: 0.7210045004103346,
      15.06: 0.721700390962415,
      15.07: 0.7223955710779473,
      15.08: 0.7230900399373583,
      15.09: 0.7237837967207573,
      '15.10': 0.7244768406079476,
      15.11: 0.7251691707784339,
      15.12: 0.7258607864114317,
      15.13: 0.7265516866858778,
      15.14: 0.7272418707804367,
      15.15: 0.7279313378735118,
      15.16: 0.7286200871432532,
      15.17: 0.7293081177675674,
      15.18: 0.7299954289241258,
      15.19: 0.730682019790374,
      '15.20': 0.7313678895435413,
      15.21: 0.7320530373606481,
      15.22: 0.7327374624185166,
      15.23: 0.7334211638937801,
      15.24: 0.7341041409628898,
      15.25: 0.7347863928021255,
      15.26: 0.7354679185876047,
      15.27: 0.7361487174952914,
      15.28: 0.736828788701004,
      15.29: 0.7375081313804261,
      '15.30': 0.7381867447091137,
      15.31: 0.7388646278625071,
      15.32: 0.7395417800159354,
      15.33: 0.74021820034463,
      15.34: 0.7408938880237308,
      15.35: 0.7415688422282974,
      15.36: 0.7422430621333148,
      15.37: 0.742916546913707,
      15.38: 0.7435892957443414,
      15.39: 0.7442613078000404,
      '15.40': 0.744932582255591,
      15.41: 0.7456031182857517,
      15.42: 0.7462729150652628,
      15.43: 0.7469419717688558,
      15.44: 0.7476102875712609,
      15.45: 0.7482778616472175,
      15.46: 0.7489446931714825,
      15.47: 0.7496107813188397,
      15.48: 0.7502761252641079,
      15.49: 0.7509407241821519,
      '15.50': 0.7516045772478892,
      15.51: 0.7522676836362997,
      15.52: 0.7529300425224361,
      15.53: 0.7535916530814321,
      15.54: 0.7542525144885092,
      15.55: 0.7549126259189903,
      15.56: 0.7555719865483046,
      15.57: 0.7562305955519981,
      15.58: 0.7568884521057436,
      15.59: 0.7575455553853477,
      '15.60': 0.7582019045667618,
      15.61: 0.7588574988260904,
      15.62: 0.7595123373395983,
      15.63: 0.7601664192837239,
      15.64: 0.7608197438350828,
      15.65: 0.7614723101704818,
      15.66: 0.7621241174669244,
      15.67: 0.7627751649016214,
      15.68: 0.7634254516520008,
      15.69: 0.7640749768957145,
      '15.70': 0.764723739810648,
      15.71: 0.7653717395749313,
      15.72: 0.766018975366946,
      15.73: 0.7666654463653342,
      15.74: 0.7673111517490094,
      15.75: 0.7679560906971633,
      15.76: 0.768600262389276,
      15.77: 0.7692436660051253,
      15.78: 0.769886300724795,
      15.79: 0.7705281657286837,
      '15.80': 0.7711692601975152,
      15.81: 0.7718095833123457,
      15.82: 0.7724491342545738,
      15.83: 0.7730879122059506,
      15.84: 0.7737259163485861,
      15.85: 0.7743631458649605,
      15.86: 0.7749995999379319,
      15.87: 0.7756352777507465,
      15.88: 0.7762701784870464,
      15.89: 0.7769043013308793,
      '15.90': 0.777537645466707,
      15.91: 0.7781702100794158,
      15.92: 0.7788019943543233,
      15.93: 0.7794329974771894,
      15.94: 0.7800632186342241,
      15.95: 0.7806926570120976,
      15.96: 0.7813213117979477,
      15.97: 0.7819491821793909,
      15.98: 0.7825762673445297,
      15.99: 0.783202566481962,
      '16.00': 0.7838280787807906,
      16.01: 0.7844528034306323,
      16.02: 0.7850767396216265,
      16.03: 0.7856998865444439,
      16.04: 0.7863222433902962,
      16.05: 0.7869438093509445,
      16.06: 0.7875645836187095,
      16.07: 0.788184565386479,
      16.08: 0.788803753847718,
      16.09: 0.7894221481964763,
      '16.10': 0.7900397476274004,
      16.11: 0.7906565513357384,
      16.12: 0.7912725585173536,
      16.13: 0.7918877683687293,
      16.14: 0.7925021800869806,
      16.15: 0.7931157928698626,
      16.16: 0.7937286059157797,
      16.17: 0.7943406184237922,
      16.18: 0.7949518295936296,
      16.19: 0.7955622386256979,
      '16.20': 0.7961718447210854,
      16.21: 0.7967806470815764,
      16.22: 0.797388644909658,
      16.23: 0.7979958374085293,
      16.24: 0.7986022237821102,
      16.25: 0.7992078032350509,
      16.26: 0.7998125749727412,
      16.27: 0.8004165382013181,
      16.28: 0.8010196921276763,
      16.29: 0.8016220359594769,
      '16.30': 0.8022235689051561,
      16.31: 0.802824290173934,
      16.32: 0.8034241989758241,
      16.33: 0.8040232945216427,
      16.34: 0.804621576023016,
      16.35: 0.8052190426923922,
      16.36: 0.8058156937430481,
      16.37: 0.8064115283890979,
      16.38: 0.8070065458455048,
      16.39: 0.8076007453280875,
      '16.40': 0.8081941260535298,
      16.41: 0.8087866872393903,
      16.42: 0.8093784281041115,
      16.43: 0.8099693478670278,
      16.44: 0.8105594457483749,
      16.45: 0.8111487209692991,
      16.46: 0.8117371727518669,
      16.47: 0.8123248003190724,
      16.48: 0.8129116028948474,
      16.49: 0.8134975797040704,
      '16.50': 0.814082729972576,
      16.51: 0.8146670529271628,
      16.52: 0.8152505477956031,
      16.53: 0.8158332138066516,
      16.54: 0.8164150501900551,
      16.55: 0.8169960561765612,
      16.56: 0.8175762309979265,
      16.57: 0.818155573886927,
      16.58: 0.8187340840773654,
      16.59: 0.819311760804083,
      '16.60': 0.819888603302965,
      16.61: 0.8204646108109519,
      16.62: 0.8210397825660488,
      16.63: 0.8216141178073327,
      16.64: 0.8221876157749629,
      16.65: 0.8227602757101891,
      16.66: 0.8233320968553615,
      16.67: 0.8239030784539391,
      16.68: 0.824473219750498,
      16.69: 0.8250425199907421,
      '16.70': 0.8256109784215108,
      16.71: 0.8261785942907889,
      16.72: 0.826745366847715,
      16.73: 0.8273112953425898,
      16.74: 0.8278763790268879,
      16.75: 0.8284406171532632,
      16.76: 0.8290040089755608,
      16.77: 0.8295665537488239,
      16.78: 0.8301282507293045,
      16.79: 0.8306890991744716,
      '16.80': 0.8312490983430203,
      16.81: 0.8318082474948806,
      16.82: 0.8323665458912268,
      16.83: 0.8329239927944869,
      16.84: 0.8334805874683505,
      16.85: 0.8340363291777779,
      16.86: 0.8345912171890111,
      16.87: 0.8351452507695803,
      16.88: 0.8356984291883146,
      16.89: 0.8362507517153493,
      '16.90': 0.8368022176221374,
      16.91: 0.8373528261814566,
      16.92: 0.837902576667419,
      16.93: 0.8384514683554793,
      16.94: 0.838999500522446,
      16.95: 0.8395466724464886,
      16.96: 0.840092983407146,
      16.97: 0.8406384326853379,
      16.98: 0.8411830195633714,
      16.99: 0.8417267433249519,
      '17.00': 0.8422696032551907,
      17.01: 0.8428115986406151,
      17.02: 0.8433527287691762,
      17.03: 0.8438929929302602,
      17.04: 0.8444323904146942,
      17.05: 0.8449709205147573,
      17.06: 0.8455085825241895,
      17.07: 0.8460453757382009,
      17.08: 0.8465812994534793,
      17.09: 0.8471163529682005,
      '17.10': 0.8476505355820376,
      17.11: 0.8481838465961682,
      17.12: 0.848716285313286,
      17.13: 0.8492478510376069,
      17.14: 0.849778543074881,
      17.15: 0.8503083607323997,
      17.16: 0.8508373033190046,
      17.17: 0.851365370145098,
      17.18: 0.8518925605226498,
      17.19: 0.8524188737652098,
      '17.20': 0.8529443091879128,
      17.21: 0.8534688661074901,
      17.22: 0.8539925438422781,
      17.23: 0.8545153417122265,
      17.24: 0.8550372590389094,
      17.25: 0.8555582951455305,
      17.26: 0.8560784493569369,
      17.27: 0.8565977209996244,
      17.28: 0.8571161094017481,
      17.29: 0.8576336138931309,
      '17.30': 0.8581502338052729,
      17.31: 0.8586659684713607,
      17.32: 0.8591808172262757,
      17.33: 0.8596947794066025,
      17.34: 0.8602078543506405,
      17.35: 0.8607200413984101,
      17.36: 0.8612313398916631,
      17.37: 0.8617417491738917,
      17.38: 0.8622512685903372,
      17.39: 0.862759897487999,
      '17.40': 0.8632676352156438,
      17.41: 0.8637744811238143,
      17.42: 0.8642804345648392,
      17.43: 0.8647854948928408,
      17.44: 0.8652896614637453,
      17.45: 0.8657929336352903,
      17.46: 0.8662953107670357,
      17.47: 0.8667967922203716,
      17.48: 0.8672973773585271,
      17.49: 0.8677970655465794,
      '17.50': 0.8682958561514643,
      17.51: 0.8687937485419835,
      17.52: 0.8692907420888134,
      17.53: 0.8697868361645158,
      17.54: 0.8702820301435457,
      17.55: 0.8707763234022606,
      17.56: 0.8712697153189299,
      17.57: 0.8717622052737426,
      17.58: 0.8722537926488179,
      17.59: 0.8727444768282143,
      '17.60': 0.8732342571979368,
      17.61: 0.873723133145947,
      17.62: 0.8742111040621727,
      17.63: 0.8746981693385166,
      17.64: 0.8751843283688647,
      17.65: 0.8756695805490952,
      17.66: 0.8761539252770886,
      17.67: 0.8766373619527368,
      17.68: 0.8771198899779498,
      17.69: 0.8776015087566676,
      '17.70': 0.8780822176948677,
      17.71: 0.8785620162005746,
      17.72: 0.8790409036838684,
      17.73: 0.8795188795568935,
      17.74: 0.8799959432338692,
      17.75: 0.8804720941310972,
      17.76: 0.8809473316669713,
      17.77: 0.8814216552619856,
      17.78: 0.8818950643387445,
      17.79: 0.8823675583219722,
      '17.80': 0.8828391366385194,
      17.81: 0.8833097987173751,
      17.82: 0.8837795439896731,
      17.83: 0.8842483718887032,
      17.84: 0.8847162818499191,
      17.85: 0.885183273310947,
      17.86: 0.8856493457115959,
      17.87: 0.8861144984938655,
      17.88: 0.8865787311019558,
      17.89: 0.8870420429822754,
      '17.90': 0.887504433583452,
      17.91: 0.8879659023563397,
      17.92: 0.8884264487540294,
      17.93: 0.8888860722318566,
      17.94: 0.8893447722474113,
      17.95: 0.8898025482605473,
      17.96: 0.8902593997333897,
      17.97: 0.8907153261303457,
      17.98: 0.891170326918112,
      17.99: 0.8916244015656858,
      '18.00': 0.8920775495443715,
      18.01: 0.892529770327791,
      18.02: 0.8929810633918934,
      18.03: 0.8934314282149628,
      18.04: 0.8938808642776274,
      18.05: 0.8943293710628688,
      18.06: 0.8947769480560318,
      18.07: 0.8952235947448319,
      18.08: 0.8956693106193657,
      18.09: 0.8961140951721186,
      '18.10': 0.8965579478979752,
      18.11: 0.8970008682942273,
      18.12: 0.8974428558605836,
      18.13: 0.8978839100991773,
      18.14: 0.898324030514578,
      18.15: 0.8987632166137979,
      18.16: 0.8992014679063013,
      18.17: 0.8996387839040151,
      18.18: 0.9000751641213366,
      18.19: 0.9005106080751428,
      '18.20': 0.9009451152847993,
      18.21: 0.9013786852721695,
      18.22: 0.9018113175616235,
      18.23: 0.9022430116800472,
      18.24: 0.9026737671568515,
      18.25: 0.9031035835239806,
      18.26: 0.9035324603159222,
      18.27: 0.9039603970697156,
      18.28: 0.9043873933249604,
      18.29: 0.9048134486238266,
      '18.30': 0.9052385625110632,
      18.31: 0.9056627345340071,
      18.32: 0.9060859642425919,
      18.33: 0.9065082511893572,
      18.34: 0.9069295949294576,
      18.35: 0.9073499950206717,
      18.36: 0.9077694510234116,
      18.37: 0.90818796250073,
      18.38: 0.9086055290183324,
      18.39: 0.9090221501445834,
      '18.40': 0.909437825450517,
      18.41: 0.9098525545098446,
      18.42: 0.9102663368989659,
      18.43: 0.910679172196976,
      18.44: 0.9110910599856755,
      18.45: 0.911501999849578,
      18.46: 0.9119119913759225,
      18.47: 0.912321034154678,
      18.48: 0.9127291277785565,
      18.49: 0.9131362718430188,
      '18.50': 0.9135424659462861,
      18.51: 0.9139477096893472,
      18.52: 0.9143520026759687,
      18.53: 0.9147553445127029,
      18.54: 0.9151577348088977,
      18.55: 0.9155591731767061,
      18.56: 0.9159596592310935,
      18.57: 0.9163591925898477,
      18.58: 0.9167577728735884,
      18.59: 0.9171553997057762,
      '18.60': 0.91755207271272,
      18.61: 0.9179477915235876,
      18.62: 0.9183425557704147,
      18.63: 0.918736365088113,
      18.64: 0.9191292191144804,
      18.65: 0.9195211174902085,
      18.66: 0.9199120598588927,
      18.67: 0.9203020458670417,
      18.68: 0.920691075164085,
      18.69: 0.9210791474023827,
      '18.70': 0.9214662622372353,
      18.71: 0.921852419326891,
      18.72: 0.9222376183325566,
      18.73: 0.9226218589184046,
      18.74: 0.9230051407515844,
      18.75: 0.9233874635022286,
      18.76: 0.9237688268434654,
      18.77: 0.9241492304514243,
      18.78: 0.9245286740052467,
      18.79: 0.924907157187096,
      '18.80': 0.9252846796821644,
      18.81: 0.925661241178683,
      18.82: 0.9260368413679307,
      18.83: 0.926411479944244,
      18.84: 0.9267851566050246,
      18.85: 0.9271578710507488,
      18.86: 0.9275296229849778,
      18.87: 0.9279004121143658,
      18.88: 0.9282702381486677,
      18.89: 0.9286391008007505,
      '18.90': 0.9290069997866005,
      18.91: 0.9293739348253339,
      18.92: 0.9297399056392046,
      18.93: 0.9301049119536127,
      18.94: 0.9304689534971152,
      18.95: 0.9308320300014348,
      18.96: 0.9311941412014669,
      18.97: 0.9315552868352909,
      18.98: 0.9319154666441783,
      18.99: 0.9322746803726017,
      '19.00': 0.9326329277682441,
      19.01: 0.9329902085820069,
      19.02: 0.9333465225680206,
      19.03: 0.933701869483653,
      19.04: 0.9340562490895173,
      19.05: 0.9344096611494828,
      19.06: 0.9347621054306824,
      19.07: 0.9351135817035235,
      19.08: 0.9354640897416946,
      19.09: 0.9358136293221758,
      '19.10': 0.9361622002252483,
      19.11: 0.9365098022345022,
      19.12: 0.9368564351368455,
      19.13: 0.9372020987225146,
      19.14: 0.937546792785082,
      19.15: 0.9378905171214653,
      19.16: 0.9382332715319369,
      19.17: 0.9385750558201328,
      19.18: 0.9389158697930612,
      19.19: 0.9392557132611125,
      '19.20': 0.9395945860380668,
      19.21: 0.9399324879411041,
      19.22: 0.9402694187908134,
      19.23: 0.9406053784112008,
      19.24: 0.9409403666296994,
      19.25: 0.9412743832771776,
      19.26: 0.9416074281879487,
      19.27: 0.94193950119978,
      19.28: 0.9422706021539008,
      19.29: 0.9426007308950125,
      '19.30': 0.9429298872712973,
      19.31: 0.9432580711344276,
      19.32: 0.9435852823395735,
      19.33: 0.9439115207454134,
      19.34: 0.9442367862141431,
      19.35: 0.9445610786114835,
      19.36: 0.9448843978066908,
      19.37: 0.9452067436725643,
      19.38: 0.9455281160854575,
      19.39: 0.9458485149252847,
      '19.40': 0.946167940075532,
      19.41: 0.9464863914232641,
      19.42: 0.9468038688591361,
      19.43: 0.947120372277401,
      19.44: 0.9474359015759175,
      19.45: 0.9477504566561618,
      19.46: 0.9480640374232339,
      19.47: 0.948376643785869,
      19.48: 0.9486882756564445,
      19.49: 0.9489989329509904,
      '19.50': 0.9493086155891975,
      19.51: 0.9496173234944273,
      19.52: 0.9499250565937197,
      19.53: 0.9502318148178034,
      19.54: 0.9505375981011033,
      19.55: 0.9508424063817521,
      19.56: 0.9511462396015965,
      19.57: 0.9514490977062074,
      19.58: 0.95175098064489,
      19.59: 0.952051888370691,
      '19.60': 0.952351820840408,
      19.61: 0.9526507780145999,
      19.62: 0.9529487598575946,
      19.63: 0.953245766337498,
      19.64: 0.9535417974262038,
      19.65: 0.9538368530994016,
      19.66: 0.9541309333365872,
      19.67: 0.9544240381210701,
      19.68: 0.9547161674399834,
      19.69: 0.955007321284293,
      '19.70': 0.9552974996488056,
      19.71: 0.9555867025321796,
      19.72: 0.9558749299369317,
      19.73: 0.9561621818694476,
      19.74: 0.9564484583399907,
      19.75: 0.956733759362711,
      19.76: 0.9570180849556538,
      19.77: 0.9573014351407692,
      19.78: 0.9575838099439207,
      19.79: 0.9578652093948951,
      '19.80': 0.95814563352741,
      19.81: 0.9584250823791245,
      19.82: 0.9587035559916468,
      19.83: 0.958981054410544,
      19.84: 0.9592575776853511,
      19.85: 0.9595331258695795,
      19.86: 0.959807699020727,
      19.87: 0.960081297200286,
      19.88: 0.9603539204737522,
      19.89: 0.9606255689106341,
      '19.90': 0.9608962425844632,
      19.91: 0.9611659415728008,
      19.92: 0.9614346659572481,
      19.93: 0.9617024158234562,
      19.94: 0.9619691912611328,
      19.95: 0.9622349923640536,
      19.96: 0.9624998192300697,
      19.97: 0.9627636719611171,
      19.98: 0.9630265506632265,
      19.99: 0.9632884554465309,
      '20.00': 0.9635493864252758,
      20.01: 0.9638093437178273,
      20.02: 0.964068327446682,
      20.03: 0.9643263377384755,
      20.04: 0.9645833747239914,
      20.05: 0.9648394385381701,
      20.06: 0.965094529320119,
      20.07: 0.9653486472131201,
      20.08: 0.9656017923646394,
      20.09: 0.9658539649263369,
      '20.10': 0.9661051650540737,
      20.11: 0.9663553929079234,
      20.12: 0.9666046486521788,
      20.13: 0.9668529324553623,
      20.14: 0.9671002444902348,
      20.15: 0.9673465849338048,
      20.16: 0.9675919539673362,
      20.17: 0.9678363517763593,
      20.18: 0.9680797785506774,
      20.19: 0.9683222344843793,
      '20.20': 0.9685637197758439,
      20.21: 0.968804234627753,
      20.22: 0.9690437792470985,
      20.23: 0.9692823538451917,
      20.24: 0.9695199586376724,
      20.25: 0.9697565938445175,
      20.26: 0.9699922596900511,
      20.27: 0.9702269564029526,
      20.28: 0.9704606842162661,
      20.29: 0.9706934433674085,
      '20.30': 0.9709252340981801,
      20.31: 0.9711560566547728,
      20.32: 0.9713859112877788,
      20.33: 0.9716147982522,
      20.34: 0.9718427178074569,
      20.35: 0.972069670217398,
      20.36: 0.9722956557503083,
      20.37: 0.9725206746789182,
      20.38: 0.9727447272804137,
      20.39: 0.9729678138364438,
      '20.40': 0.9731899346331304,
      20.41: 0.9734110899610773,
      20.42: 0.9736312801153791,
      20.43: 0.9738505053956307,
      20.44: 0.9740687661059351,
      20.45: 0.9742860625549132,
      20.46: 0.9745023950557132,
      20.47: 0.9747177639260195,
      20.48: 0.9749321694880605,
      20.49: 0.9751456120686193,
      '20.50': 0.9753580919990414,
      20.51: 0.9755696096152447,
      20.52: 0.9757801652577286,
      20.53: 0.9759897592715812,
      20.54: 0.9761983920064903,
      20.55: 0.9764060638167521,
      20.56: 0.9766127750612794,
      20.57: 0.9768185261036114,
      20.58: 0.9770233173119222,
      20.59: 0.9772271490590301,
      '20.60': 0.9774300217224066,
      20.61: 0.977631935684185,
      20.62: 0.9778328913311704,
      20.63: 0.9780328890548475,
      20.64: 0.9782319292513911,
      20.65: 0.978430012321673,
      20.66: 0.9786271386712733,
      20.67: 0.9788233087104877,
      20.68: 0.9790185228543378,
      20.69: 0.9792127815225791,
      '20.70': 0.9794060851397102,
      20.71: 0.9795984341349827,
      20.72: 0.9797898289424093,
      20.73: 0.9799802700007727,
      20.74: 0.9801697577536357,
      20.75: 0.9803582926493488,
      20.76: 0.9805458751410608,
      20.77: 0.9807325056867259,
      20.78: 0.9809181847491146,
      20.79: 0.9811029127958217,
      '20.80': 0.9812866902992755,
      20.81: 0.9814695177367466,
      20.82: 0.9816513955903573,
      20.83: 0.9818323243470907,
      20.84: 0.9820123044987994,
      20.85: 0.9821913365422141,
      20.86: 0.9823694209789537,
      20.87: 0.982546558315534,
      20.88: 0.9827227490633756,
      20.89: 0.9828979937388144,
      '20.90': 0.9830722928631097,
      20.91: 0.9832456469624535,
      20.92: 0.9834180565679802,
      20.93: 0.9835895222157741,
      20.94: 0.9837600444468798,
      20.95: 0.9839296238073103,
      20.96: 0.9840982608480565,
      20.97: 0.9842659561250966,
      20.98: 0.9844327101994043,
      20.99: 0.9845985236369579,
      '21.00': 0.98476339700875,
      21.01: 0.9849273308907961,
      21.02: 0.985090325864143,
      21.03: 0.9852523825148796,
      21.04: 0.9854135014341435,
      21.05: 0.9855736832181322,
      21.06: 0.9857329284681108,
      21.07: 0.9858912377904211,
      21.08: 0.9860486117964918,
      21.09: 0.986205051102846,
      '21.10': 0.986360556331111,
      21.11: 0.9865151281080271,
      21.12: 0.9866687670654569,
      21.13: 0.986821473840394,
      21.14: 0.9869732490749724,
      21.15: 0.9871240934164748,
      21.16: 0.9872740075173426,
      21.17: 0.9874229920351837,
      21.18: 0.987571047632783,
      21.19: 0.9877181749781102,
      '21.20': 0.9878643747443293,
      21.21: 0.9880096476098076,
      21.22: 0.9881539942581247,
      21.23: 0.9882974153780817,
      21.24: 0.9884399116637095,
      21.25: 0.9885814838142789,
      21.26: 0.9887221325343089,
      21.27: 0.9888618585335757,
      21.28: 0.989000662527122,
      21.29: 0.9891385452352661,
      '21.30': 0.9892755073836106,
      21.31: 0.9894115497030515,
      21.32: 0.9895466729297876,
      21.33: 0.9896808778053283,
      21.34: 0.9898141650765048,
      21.35: 0.9899465354954766,
      21.36: 0.9900779898197429,
      21.37: 0.9902085288121493,
      21.38: 0.990338153240899,
      21.39: 0.9904668638795602,
      '21.40': 0.9905946615070761,
      21.41: 0.990721546907773,
      21.42: 0.9908475208713705,
      21.43: 0.9909725841929895,
      21.44: 0.9910967376731621,
      21.45: 0.9912199821178388,
      21.46: 0.9913423183384004,
      21.47: 0.9914637471516646,
      21.48: 0.9915842693798961,
      21.49: 0.9917038858508153,
      '21.50': 0.9918225973976075,
      21.51: 0.9919404048589319,
      21.52: 0.9920573090789301,
      21.53: 0.9921733109072362,
      21.54: 0.9922884111989847,
      21.55: 0.9924026108148204,
      21.56: 0.9925159106209067,
      21.57: 0.9926283114889348,
      21.58: 0.9927398142961334,
      21.59: 0.9928504199252769,
      '21.60': 0.9929601292646945,
      21.61: 0.9930689432082793,
      21.62: 0.9931768626554982,
      21.63: 0.9932838885113993,
      21.64: 0.9933900216866224,
      21.65: 0.9934952630974068,
      21.66: 0.9935996136656016,
      21.67: 0.9937030743186732,
      21.68: 0.9938056459897159,
      21.69: 0.9939073296174596,
      '21.70': 0.9940081261462795,
      21.71: 0.9941080365262055,
      21.72: 0.9942070617129302,
      21.73: 0.9943052026678184,
      21.74: 0.9944024603579161,
      21.75: 0.9944988357559604,
      21.76: 0.9945943298403863,
      21.77: 0.9946889435953385,
      21.78: 0.9947826780106783,
      21.79: 0.994875534081993,
      '21.80': 0.994967512810606,
      21.81: 0.995058615203585,
      21.82: 0.9951488422737503,
      21.83: 0.9952381950396858,
      21.84: 0.9953266745257456,
      21.85: 0.9954142817620656,
      21.86: 0.9955010177845699,
      21.87: 0.9955868836349818,
      21.88: 0.9956718803608324,
      21.89: 0.995756009015468,
      '21.90': 0.995839270658062,
      21.91: 0.9959216663536217,
      21.92: 0.9960031971729978,
      21.93: 0.9960838641928937,
      21.94: 0.9961636684958747,
      21.95: 0.9962426111703764,
      21.96: 0.9963206933107143,
      21.97: 0.9963979160170923,
      21.98: 0.9964742803956126,
      21.99: 0.9965497875582832,
      '22.00': 0.9966244386230285,
      22.01: 0.9966982347136977,
      22.02: 0.9967711769600732,
      22.03: 0.9968432664978807,
      22.04: 0.9969145044687974,
      22.05: 0.9969848920204616,
      22.06: 0.9970544303064813,
      22.07: 0.9971231204864434,
      22.08: 0.9971909637259223,
      22.09: 0.9972579611964901,
      '22.10': 0.997324114075724,
      22.11: 0.9973894235472165,
      22.12: 0.9974538908005843,
      22.13: 0.9975175170314766,
      22.14: 0.997580303441585,
      22.15: 0.9976422512386517,
      22.16: 0.9977033616364792,
      22.17: 0.997763635854939,
      22.18: 0.9978230751199806,
      22.19: 0.9978816806636407,
      '22.20': 0.9979394537240516,
      22.21: 0.9979963955454518,
      22.22: 0.998052507378193,
      22.23: 0.9981077904787505,
      22.24: 0.9981622461097314,
      22.25: 0.9982158755398841,
      22.26: 0.9982686800441076,
      22.27: 0.9983206609034598,
      22.28: 0.9983718194051667,
      22.29: 0.998422156842632,
      '22.30': 0.9984716745154453,
      22.31: 0.9985203737293916,
      22.32: 0.9985682557964608,
      22.33: 0.9986153220348547,
      22.34: 0.9986615737689992,
      22.35: 0.9987070123295503,
      22.36: 0.998751639053405,
      22.37: 0.9987954552837093,
      22.38: 0.9988384623698684,
      22.39: 0.9988806616675542,
      '22.40': 0.9989220545387152,
      22.41: 0.9989626423515857,
      22.42: 0.9990024264806942,
      22.43: 0.9990414083068728,
      22.44: 0.9990795892172664,
      22.45: 0.999116970605341,
      22.46: 0.9991535538708936,
      22.47: 0.9991893404200604,
      22.48: 0.9992243316653268,
      22.49: 0.9992585290255349,
      '22.50': 0.9992919339258945,
      22.51: 0.9993245477979908,
      22.52: 0.999356372079793,
      22.53: 0.9993874082156649,
      22.54: 0.9994176576563722,
      22.55: 0.9994471218590932,
      22.56: 0.9994758022874265,
      22.57: 0.9995037004114002,
      22.58: 0.999530817707482,
      22.59: 0.9995571556585865,
      '22.60': 0.9995827157540857,
      22.61: 0.9996074994898178,
      22.62: 0.999631508368095,
      22.63: 0.9996547438977138,
      22.64: 0.9996772075939637,
      22.65: 0.9996989009786361,
      22.66: 0.9997198255800337,
      22.67: 0.9997399829329782,
      22.68: 0.999759374578821,
      22.69: 0.9997780020654516,
      '22.70': 0.999795866947306,
      22.71: 0.999812970785377,
      22.72: 0.9998293151472217,
      22.73: 0.9998449016069715,
      22.74: 0.9998597317453412,
      22.75: 0.9998738071496374,
      22.76: 0.9998871294137677,
      22.77: 0.9998997001382504,
      22.78: 0.9999115209302228,
      22.79: 0.9999225934034497,
      '22.80': 0.9999329191783344,
      22.81: 0.9999424998819251,
      22.82: 0.9999513371479257,
      22.83: 0.9999594326167051,
      22.84: 0.9999667879353046,
      22.85: 0.9999734047574478,
      22.86: 0.9999792847435502,
      22.87: 0.9999844295607274,
      22.88: 0.9999888408828042,
      22.89: 0.9999925203903235,
      '22.90': 0.9999954697705564,
      22.91: 0.9999976907175102,
      22.92: 0.9999991849319366,
      22.93: 0.9999999541213432,
      22.94: 1.0,
      22.95: 1.0,
      22.96: 1.0,
      22.97: 1.0,
      22.98: 1.0,
      22.99: 1.0,
      '23.00': 1.0,
      23.01: 1.0,
      23.02: 1.0,
      23.03: 1.0,
      23.04: 1.0,
      23.05: 1.0,
      23.06: 1.0,
      23.07: 1.0,
      23.08: 1.0,
      23.09: 1.0,
      '23.10': 1.0,
      23.11: 1.0,
      23.12: 1.0,
      23.13: 1.0,
      23.14: 1.0,
      23.15: 1.0,
      23.16: 1.0,
      23.17: 1.0,
      23.18: 1.0,
      23.19: 1.0,
      '23.20': 1.0,
      23.21: 1.0,
      23.22: 1.0,
      23.23: 1.0,
      23.24: 1.0,
      23.25: 1.0,
      23.26: 1.0,
      23.27: 1.0,
      23.28: 1.0,
      23.29: 1.0,
      '23.30': 1.0,
      23.31: 1.0,
      23.32: 1.0,
      23.33: 1.0,
      23.34: 1.0,
      23.35: 1.0,
      23.36: 1.0,
      23.37: 1.0,
      23.38: 1.0,
      23.39: 1.0,
      '23.40': 1.0,
      23.41: 1.0,
      23.42: 1.0,
      23.43: 1.0,
      23.44: 1.0,
      23.45: 1.0,
      23.46: 1.0,
      23.47: 1.0,
      23.48: 1.0,
      23.49: 1.0,
      '23.50': 1.0,
      23.51: 1.0,
      23.52: 1.0,
      23.53: 1.0,
      23.54: 1.0,
      23.55: 1.0,
      23.56: 1.0,
      23.57: 1.0,
      23.58: 1.0,
      23.59: 1.0,
      '23.60': 1.0,
      23.61: 1.0,
      23.62: 1.0,
      23.63: 1.0,
      23.64: 1.0,
      23.65: 1.0,
      23.66: 1.0,
      23.67: 1.0,
      23.68: 1.0,
      23.69: 1.0,
      '23.70': 1.0,
      23.71: 1.0,
      23.72: 1.0,
      23.73: 1.0,
      23.74: 1.0,
      23.75: 1.0,
      23.76: 1.0,
      23.77: 1.0,
      23.78: 1.0,
      23.79: 1.0,
      '23.80': 1.0,
      23.81: 1.0,
      23.82: 1.0,
      23.83: 1.0,
      23.84: 1.0,
      23.85: 1.0,
      23.86: 1.0,
      23.87: 1.0,
      23.88: 1.0,
      23.89: 1.0,
      '23.90': 1.0,
      23.91: 1.0,
      23.92: 1.0,
      23.93: 1.0,
      23.94: 1.0,
      23.95: 1.0,
      23.96: 1.0,
      23.97: 1.0,
      23.98: 1.0,
      23.99: 1.0,
      '24.00': 1.0,
      24.01: 1.0,
      24.02: 1.0,
      24.03: 1.0,
      24.04: 1.0,
      24.05: 1.0,
      24.06: 1.0,
      24.07: 1.0,
      24.08: 1.0,
      24.09: 1.0,
      '24.10': 1.0,
      24.11: 1.0,
      24.12: 1.0,
      24.13: 1.0,
      24.14: 1.0,
      24.15: 1.0,
      24.16: 1.0,
      24.17: 1.0,
      24.18: 1.0,
      24.19: 1.0,
      '24.20': 1.0,
      24.21: 1.0,
      24.22: 1.0,
      24.23: 1.0,
      24.24: 1.0,
      24.25: 1.0,
      24.26: 1.0,
      24.27: 1.0,
      24.28: 1.0,
      24.29: 1.0,
      '24.30': 1.0,
      24.31: 1.0,
      24.32: 1.0,
      24.33: 1.0,
      24.34: 1.0,
      24.35: 1.0,
      24.36: 1.0,
      24.37: 1.0,
      24.38: 1.0,
      24.39: 1.0,
      '24.40': 1.0,
      24.41: 1.0,
      24.42: 1.0,
      24.43: 1.0,
      24.44: 1.0,
      24.45: 1.0,
      24.46: 1.0,
      24.47: 1.0,
      24.48: 1.0,
      24.49: 1.0,
      '24.50': 1.0,
      24.51: 1.0,
      24.52: 1.0,
      24.53: 1.0,
      24.54: 1.0,
      24.55: 1.0,
      24.56: 1.0,
      24.57: 1.0,
      24.58: 1.0,
      24.59: 1.0,
      '24.60': 1.0,
      24.61: 1.0,
      24.62: 1.0,
      24.63: 1.0,
      24.64: 1.0,
      24.65: 1.0,
      24.66: 1.0,
      24.67: 1.0,
      24.68: 1.0,
      24.69: 1.0,
      '24.70': 1.0,
      24.71: 1.0,
      24.72: 1.0,
      24.73: 1.0,
      24.74: 1.0,
      24.75: 1.0,
      24.76: 1.0,
      24.77: 1.0,
      24.78: 1.0,
      24.79: 1.0,
      '24.80': 1.0,
      24.81: 1.0,
      24.82: 1.0,
      24.83: 1.0,
      24.84: 1.0,
      24.85: 1.0,
      24.86: 1.0,
      24.87: 1.0,
      24.88: 1.0,
      24.89: 1.0,
      '24.90': 1.0,
      24.91: 1.0,
      24.92: 1.0,
      24.93: 1.0,
      24.94: 1.0,
      24.95: 1.0,
      24.96: 1.0,
      24.97: 1.0,
      24.98: 1.0,
      24.99: 1.0,
      Other: 1.0,
    },
    lead_time: {
      1: 0.5243714362009166,
      2: 0.5416603269989592,
      3: 0.5585300733558973,
      4: 0.5749872537820366,
      5: 0.5910383835076632,
      6: 0.6066899147679715,
      7: 0.6219482370879827,
      8: 0.6368196775674693,
      9: 0.6513105011658782,
      10: 0.6654269109872543,
      11: 0.6791750485651595,
      12: 0.6925609941475999,
      13: 0.7055907669819459,
      14: 0.7182703255998553,
      15: 0.7306055681021977,
      16: 0.7426023324439737,
      17: 0.7542663967192417,
      18: 0.765603479446038,
      19: 0.7766192398513002,
      20: 0.7873192781557908,
      21: 0.7977091358590188,
      22: 0.8077942960241624,
      23: 0.8175801835629936,
      24: 0.8270721655207973,
      25: 0.8362755513612985,
      26: 0.8451955932515812,
      27: 0.853837486347014,
      28: 0.8622063690761709,
      29: 0.8703073234257545,
      30: 0.8781453752255202,
      31: 0.8857254944331958,
      32: 0.8930525954194086,
      33: 0.9001315372526039,
      34: 0.9069671239839697,
      35: 0.91356410493236,
      36: 0.919927174969217,
      Other: 0.919927174969217,
    },
    category: {
      Administrative: 0.9331488205718859,
      'Brand Ambassador': 0.8195090446145392,
      'Customer Service': 0.8741099174854132,
      'Data Entry': 0.7683493205435012,
      Delivery: 0.8966744892299443,
      'Event Staff': 0.928519744561163,
      'Food Production': 0.8280059990735344,
      'Fulfillment / Warehousing': 0.9107678661847579,
      'General Labor': 0.8828501442881058,
      'Manufacturing/Production': 0.8978211847705726,
      'Market Research': 0.5996591829925151,
      Marketing: 0.9276119402985075,
      Merchandising: 0.7408627974051212,
      'Onboarding Event': 0.4961805555554167,
      Other: 0.9003448597695545,
      'Permanent Position': 0.8858513189441733,
      'Ready-To-Work': 0.9067619784972948,
      Sales: 0.7893282692887399,
      Security: 0.8119223100538966,
      'Software Testing': 0.8303763440860215,
      'Valet / Parking': 0.9077141336506045,
      Volunteer: 1.0,
      'Washing & Cleaning': 0.883268592712701,
    },
    location: {
      '00': 0.6220733405003642,
      10: 0.9277933851856566,
      11: 0.9478950123555546,
      12: 0.5557407407408886,
      15: 0.6125341121639409,
      18: 0.7849188319135072,
      19: 0.8895926823346141,
      20: 0.7695274081570046,
      21: 0.8154646069649572,
      24: 0.7231585518099877,
      27: 0.7296284196828432,
      28: 0.8527383833910422,
      30: 0.8739672830421522,
      32: 0.6649867369534994,
      33: 0.8668637957336967,
      37: 0.8951587807562874,
      43: 0.6813882584391047,
      45: 0.6892966075327451,
      48: 0.852409090486776,
      60: 0.9026999423131259,
      70: 0.9149059404641704,
      71: 0.7117465224111282,
      73: 0.8938222335084964,
      75: 0.9054245687450946,
      76: 0.8565306163067002,
      77: 0.6392626849898676,
      78: 0.7583825105943206,
      80: 0.8264088705690799,
      85: 0.8935430501216951,
      87: 0.8721514291033019,
      88: 0.8206700217161873,
      89: 0.8994967126466129,
      90: 0.9440420375384735,
      91: 0.9500843031211219,
      92: 0.9422614979010772,
      94: 0.9017391486740346,
      95: 0.8813945699917285,
      98: 0.8269982287851992,
      Other: 0.6220733405003642,
    },
    slots: {
      1: 0.9007959619491361,
      2: 0.7900813285559916,
      3: 0.7297281003195273,
      4: 0.6756238003838771,
      5: 0.6466366752356469,
      6: 0.6343543334493561,
      7: 0.6303605313092979,
      8: 0.5678976446641466,
      9: 0.5678976446641466,
      10: 0.5678976446641466,
      Other: 0.5678976446641466,
    },
  },
  coefficient: {
    lead_time: 0.15498512052708027,
    wage: 0.18628099656589098,
    slots: 0.21683974623276536,
    category: 0.17387479826459085,
    location: 0.2680193384096702,
  },
  threshold: {
    wage: [0.2475, 0.594],
    lead_time: [0.6218714362009168, 0.7583714362009168],
    category: [0.6211805555554161, 0.7961805555554153],
    location: [0.6532407407408887, 0.7897407407408888],
    slots: [0.6503976446641466, 0.7658976446641468],
    overall: [0.865217891785533, 0.9110612848972259],
  },
  infoText: {
    category: {
      low: {
        header: 'Based on our data, this is a developing category.',
        text:
          'New Wonoloers are joining us every day with diverse skill-sets. Be sure to describe your requirements thoroughly so that we can get you the best fit in this up-and-coming category.',
      },
      medium: {
        header: 'This is an up-and-coming category.',
        text:
          'New Wonoloers are joining us every day with diverse skill-sets. Be sure to describe your requirements thoroughly so that we can get you the best fit in this up-and-coming category.',
      },
      high: {
        header: 'This is a popular category!',
        text:
          'This is a popular category! Wonoloers love jobs in this category, and they are familiar and knowledgeable with this type of work.',
      },
    },
    lead_time: {
      low: {
        header: 'Need last minute help?',
        text:
          "We want you to have the best experience on Wonolo. Lead time helps us ensure that a larger number of qualified Wonoloers see your post before they've accepted another job. To increase the chance of filling this job, we suggest posting it with an attractive wage.",
      },
      medium: {
        header: 'Your job is coming up!',
        text:
          "We want you to have the best experience on Wonolo. Lead time helps us ensure that a larger number of qualified Wonoloers see your post before they've accepted another job. To increase the chance of filling this job, we suggest posting it with an attractive wage.",
      },
      high: {
        header: 'Perfect timing! ',
        text: "You've given enough time for Wonoloers to pick up this job.",
      },
    },
    location: {
      low: {
        header: 'This is a developing market.',
        text:
          'This is a developing market. New Wonoloers are joining us every day in this area. An attractive wage and longer lead time help ensure we are able to deliver high quality Wonoloers to your site the day of the job.',
      },
      medium: {
        header: 'Wonoloers are in high demand in this area.',
        text:
          'This is a developing market. New Wonoloers are joining us every day in this area. An attractive wage and longer lead time help ensure we are able to deliver high quality Wonoloers to your site the day of the job.',
      },
      high: {
        header: 'Wonoloers love this area!',
        text:
          'This area has a high population of Wonoloers looking for jobs like yours.',
      },
    },
    slots: {},
    wage: {
      low: {
        header: 'Based on our data, your pay seems to be below average. ',
        text:
          "We want you to have the best experience on Wonolo. Lead time helps us ensure that a larger number of qualified Wonoloers see your post before they've accepted another job. To increase the chance of filling this job, we suggest posting it with an attractive wage.",
      },
      medium: {
        header: 'Good start with the pay!',
        text:
          "We want you to have the best experience on Wonolo. Lead time helps us ensure that a larger number of qualified Wonoloers see your post before they've accepted another job. To increase the chance of filling this job, we suggest posting it with an attractive wage.",
      },
      high: {
        header: 'Great Pay!',
        text:
          'This pay is likely to attract a lot of Wonoloers to pick up the job.',
      },
    },
  },
  summaryText: {
    category: {
      low: {
        header: 'Developing Category',
        text:
          'This is still a developing job category. Please be clear with the requirements of the job.',
      },
      medium: {
        header: 'Up-and-coming Category',
        text:
          'This is still a developing job category. Please be clear with the requirements of the job.',
      },
      high: {
        header: 'Popular Category',
        text: 'Wonoloers love jobs in this category.',
      },
    },
    lead_time: {
      low: {
        header: 'Your job is coming up',
        text:
          'When there is a tight timeline, more attractive pay may help fill jobs quickly.',
      },
      medium: {
        header: 'Your job is coming up',
        text:
          'When there is a tight timeline, more attractive pay may help fill jobs quickly.',
      },
      high: {
        header: 'Perfect timing',
        text: "You've given enough time for Wonoloers to pick up this job.",
      },
    },
    slots: {},
    location: {
      low: {
        header: 'Developing Market',
        text:
          'New Wonoloers are joining daily! Competitive pay may help get your job filled.',
      },
      medium: {
        header: 'Developing market',
        text:
          'New Wonoloers are joining daily! Competitive pay may help get your job filled.',
      },
      high: {
        header: 'Great location',
        text:
          'This area has a high population of Wonoloers looking for jobs like yours!',
      },
    },
    wage: {
      low: {
        header: 'Your pay may be below average.',
        text: 'Based on our data, your pay may be below average.',
      },
      medium: {
        header: 'Your pay may be below average.',
        text: 'Based on our data, your pay may be below average.',
      },
      high: {
        header: 'Great Pay',
        text: 'This pay should attract a lot of Wonoloers to pick up the job.',
      },
    },
  },
  keyValues: { wage: { min: 7.25, max: 24.99 } },
  gaugeText: { low: 'Uncertain', medium: 'Fair', high: 'Great' },
};
